import { ShoppingCart } from "lucide-react";

// Mirrors embed.js contrastText(): dark text on light brand, white on dark.
export function contrastText(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  if (!m) return "#ffffff";
  const r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.62 ? "#111111" : "#ffffff";
}

export function BrandPreview({ color, menuCta = true }) {
  const c = color || "#0033A0";
  const txt = contrastText(c);
  const readable = txt === "#111111" ? "dark" : "light";
  const menuBg = menuCta ? c : "#111111";
  const menuTxt = menuCta ? txt : "#ffffff";
  return (
    <div className="border border-border bg-secondary/40 p-4 space-y-3" data-testid="brand-preview">
      <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Live preview</div>
      <div className="flex flex-wrap items-center gap-3">
        {/* primary CTA (cart / drawer button) */}
        <button type="button" tabIndex={-1} style={{ backgroundColor: c, color: txt }}
          className="px-4 py-2 text-sm font-semibold rounded-md cursor-default" data-testid="brand-preview-cta">
          Checkout
        </button>
        {/* floating cart pill */}
        <span style={{ backgroundColor: c, color: txt }}
          className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold rounded-full" data-testid="brand-preview-fab">
          <ShoppingCart className="h-4 w-4" /> Cart <span className="opacity-80">0</span>
        </span>
        {/* sample badge / accent */}
        <span style={{ backgroundColor: c, color: txt }}
          className="text-[10px] font-bold px-2 py-1 rounded-sm tracking-wide" data-testid="brand-preview-badge">NEW</span>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        {/* menu Add button */}
        <button type="button" tabIndex={-1} style={{ backgroundColor: menuBg, color: menuTxt }}
          className="px-4 py-2 text-sm font-semibold rounded-md cursor-default" data-testid="brand-preview-menu-btn">
          Order Now
        </button>
        <span className="text-sm font-semibold" style={{ color: c }} data-testid="brand-preview-price">$4.50</span>
        <span className="text-[11px] text-muted-foreground">
          Text auto-set to <b>{readable}</b> for readability{!menuCta && " · menu button uses neutral styling"}
        </span>
      </div>
    </div>
  );
}
